import { $, $$ } from '@starberry/components';
import { getUser } from 'core/services/store/utils';

const ProfileHero = {
  $: 'PageHero',
  props: {
    px: $('theme.space.12'),
    d: 'block',
  },
  primary: ({ userNameProps }) => {
    return [
      {
        $: 'Flex',
        props: {
          align: 'center',
        },
        children: [
          {
            $: 'Avatar',
            provide: ['auth'],
            props: {
              size: 'lg',
              mr: 5,
              name: () => getUser().name || 'Visitor',
              src: () => getUser().picture || '',
            },
          },
          {
            $: 'Text',
            provide: ['auth'],
            props: {
              fontWeight: 400,
              fontSize: $$('constants.headings.headingSize.h5', null, 'constants.headings.headingSize.h3'),
              lineHeight: $$('constants.headings.headingLineHeight.h5', null, 'constants.headings.headingLineHeight.h3'),
              ...userNameProps
            },
            children: (_, context) => context?.state?.auth?.[0]?.user?.name || 'Visitor',
          },
        ],
      },
    ];
  },
};

export default ProfileHero;
